import React from 'react';
import { Link } from 'gatsby';

import Container from '../../shared/container';
import { SocialLinks } from '../../';
import * as styles from './footer.module.css';

function getYear() {
  return new Date().getFullYear();
}

const Footer = () => (
  <Container as="footer">
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={`${styles.column} ${styles.textColumn}`}>
          <Link to="/events" className={styles.basicLink}>
            Events
          </Link>
          <Link to="/form/donate/" className={styles.basicLink}>
            Donate or Sponsor
          </Link>
          <Link to="/blog" className={styles.basicLink}>
            Blog
          </Link>
          {/* <Link to="/clustering" className={styles.basicLink}>
            Event Clustering
          </Link> */}
          <Link to="/about" className={styles.basicLink}>
            About
          </Link>
          <a className={styles.contact} href="mailto:info@wellingtonheritagefestival.nz" title="Email us">
            info@wellingtonheritagefestival.nz
          </a>
          <span className={styles.legal}>
            © Wellington Heritage Festival Trust &amp; Hiamo Ltd.
            {' '}
            {getYear()}
          </span>
          <span className={styles.legal}>
            The Wellington Heritage Festival Trust is a registered charity (<a name="Charities Services listing for the Wellington Heritage Festival Trust" href="https://register.charities.govt.nz/CharitiesRegister/ViewCharity?accountId=effef044-0d7a-ef11-bb38-000d3acc4199&redirectUrl=https%3A%2F%2Fregister.charities.govt.nz%2FCharitiesRegister%2FSearch%3FSubmitted%3DTrue%26RegistrationNumber%3DCC62729">CC62729</a>).
          </span>
        </div>
        <div className={styles.column}>
          <Link to="/" className={styles.logoLink}>
            <span className={styles.logo} />
          </Link>
        </div>
        <div className={`${styles.column} ${styles.socialWrapper}`}>
          <SocialLinks />
        </div>
      </div>
      <span className={styles.attribution}>Built by <a href="https://hiamo.nz/">Hiamo Ltd.</a></span>
    </div>
  </Container>
);

export default Footer;
